import {
  faArrowAltSquareLeft,
  faBars,
  faBook,
  faChartArea,
  faChevronDown,
  faChevronDoubleDown,
  faChevronDoubleUp,
  faChevronLeft,
  faChevronRight,
  faCaretDown,
  faChevronSquareRight,
  faChevronUp,
  faCircleNotch,
  faCircle,
  faCoffee,
  faEraser,
  faExclamation,
  faExclamationCircle,
  faFilter,
  faLocationArrow,
  faMobileAlt,
  faPaperclip,
  faPencilAlt,
  faPlus,
  faReply,
  faShareAlt,
  faStar,
  faSyncAlt,
  faTimes,
  faClipboardList,
  faTrash,
  faUser,
  faGlobe,
  faAlignLeft,
  faExpand,
  faUsers,
  faSquareFull,
  faVideo,
  faSlidersH,
  faInfoCircle,
  faPlusSquare
} from '@fortawesome/pro-solid-svg-icons'
import {
  faArrowAltSquareUp,
  faArrowAltSquareDown,
  faChevronSquareDown,
  faChevronSquareUp,
  faCheck,
  faCheckSquare,
  faEdit,
  faEye,
  faMapMarkerAlt,
  faSave,
  faLink,
  faCalendarEdit,
  faSearch,
  faFileExcel,
  faFilePdf,
  faLocationArrow as falLocationArrow,
  faQuestionCircle,
  faStar as farStar,
  faEnvelope,
  faEnvelopeOpen,
  faPrint
} from '@fortawesome/pro-regular-svg-icons'

import {
  faAsterisk,
  faCommentLines,
  faFileCheck,
  faTimes as falTimes,
  faCalendarAlt,
  faBackward,
  faFile,
  faFileExcel as falFileExcel,
  faFilePdf as falFilePdf,
  faFileWord,
  faForward,
  faStepBackward,
  faStepForward,
  faEnvelope as falEnvelope,
  faSignOut
} from '@fortawesome/pro-light-svg-icons'

// import {faGlobeAmericas} from '@fortawesome/pro-solid-svg-icons'

// import { faUserSecret } from '@fortawesome/pro-duotone-svg-icons'

import { library } from '@fortawesome/fontawesome-svg-core'

// https://github.com/FortAwesome/vue-fontawesome uitleg
library.add(
  faInfoCircle,
  faSlidersH,
  faSquareFull,
  faAlignLeft,
  faEnvelopeOpen,
  faEnvelope,
  falEnvelope,
  faSignOut,
  faArrowAltSquareLeft,
  faArrowAltSquareUp,
  faArrowAltSquareDown,
  faAsterisk,
  faBars,
  faBook,
  faChartArea,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronDoubleDown,
  faChevronDoubleUp,
  faChevronSquareRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faCoffee,
  faEdit,
  faCircle,
  faCoffee,
  faCommentLines,
  faEraser,
  faExclamation,
  faExclamationCircle,
  faEye,
  faFileCheck,
  faFilter,
  faGlobe,
  // faGlobeAmericas,
  faLocationArrow,
  faMapMarkerAlt,
  faMobileAlt,
  faPaperclip,
  faPencilAlt,
  faPlus,
  faReply,
  faSave,
  faShareAlt,
  faLink,
  faStar,
  faSyncAlt,
  faTimes,
  faCalendarEdit,
  faCalendarAlt,
  faClipboardList,
  faBackward,
  faFile,
  faFileExcel,
  faFilePdf,
  faFileWord,
  faForward,
  faStepBackward,
  faStepForward,
  falFileExcel,
  falFilePdf,
  falLocationArrow,
  faQuestionCircle,
  faPlusSquare,
  faSearch,
  farStar,
  faTrash,
  falTimes,
  faCaretDown,
  faUser,
  faChevronSquareDown,
  faChevronSquareUp,
  faPrint,
  faExpand,
  faUsers,
  faVideo
)
